var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.collections),function(collection){return _c(_vm.componentName,{key:collection.title,tag:"component",staticClass:"mb-4",attrs:{"title":collection.title,"locations":collection.locations,"query":_vm.query}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }